module.exports = __webpack_public_path__ + "img/3-onebg.2e2bf6bb.png";